import * as yup from 'yup';
import { checkPostalCode } from '../helpers/cardInfoValidator';

export const contactDetailsFormSchema = yup.object().shape({
  mobile_number: yup.string().required('Mobile Number Required'),
  address: yup.object().shape({
    line1: yup.string().required('Required'),
    line2: yup.string().required('Required'),
    state: yup.string().required('Required'),
    city: yup.string().required('Required'),
    zip_code: yup
      .string()
      .test(`postalCodeValidation`, 'Invalid Code', (value?: string) => {
        return checkPostalCode(value);
      })
      .required('Required'),
  }),
});

export const contactDetailsRestrictedFormSchema = yup.object().shape({
  first_name: yup.string().required('Required'),
  last_name: yup.string().required('Required'),
});
